import { firestore } from "../../../../backend/firebaseconfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import { determineEntityTypeFromUser } from "./determineEntityTypeFromUser";

/**
 * Fetch user details from Firestore by email.
 * @param {string} email - The user's email address.
 * @returns {Promise<Object|null>} The user data object, or null if not found.
 */

/**
 * @typedef {Object} UserData
 * @property {string} id
 * @property {string[]} status
 * @property {string} tradingName
 * @property {string} tradingStyle
 * @property {boolean} isAppointed
 * @property {string} brandName
 * @property {string[]} admins
 * @property {string} email
 * @property {string} regulatoryText
 */

/**
 * Fetch user details from Firestore by email, returned in a structured way.
 * @param {string} email - The user's email address.
 * @returns {Promise<UserData|null>} The user data object, or null if not found.
 */
export async function getUserDataByEmail(email, role) {
  if (!email) return null;
  const usersRef = collection(
    firestore,
    "Authorized Members",
    "Advisers",
    "Data",
  );
  const q = query(
    usersRef,
    where("email", "==", "hrutuja.patnekar@rosemountfs.co.u"),
  );
  const snapshot = await getDocs(q);
  if (snapshot.empty) {
    return null;
  }
  const doc = snapshot.docs[0];
  const data = doc.data();
  // Structure the data
  const userData = {
    id: doc.id,
    status: Array.isArray(data.status) ? data.status : [],
    tradingName: data.tradingName || "",
    tradingStyle: data.tradingStyle || "",
    isAppointed:
      typeof data.isAppointed === "boolean" ? data.isAppointed : false,
    brandName: data.brandName || "",
    admins: Array.isArray(data.admins) ? data.admins : [],
    email: data.email || "",
    regulatoryText: data.regulatoryText || "",
    };

    // console.log("Fetched user data:", userData);

  return {
    ...userData,
    entityType: determineEntityTypeFromUser(userData), // derived
  };
}